/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-07-09 17:51:44
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-12 00:16:50
 */

import { Injectable } from "@angular/core";
import { Platform, NavController } from "ionic-angular";
// import { Keyboard } from '@ionic-native/keyboard';
import { AlertService } from "./alert.service";
import { Network } from "@ionic-native/network";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Globalization } from "@ionic-native/globalization";

import { ENV } from "../env/env";
import { Keyboard } from "@ionic-native/keyboard";

@Injectable()
export class PlatformService {
  private _isForeground = true;

  // Property used to store the callback of the event handler to unsubscribe to it when leaving this page
  private unregisterBackButtonAction: any;

  private _network: BehaviorSubject<boolean> = new BehaviorSubject(true);
  rootPageName: string;

  private _proposeStatusTab: BehaviorSubject<string> = new BehaviorSubject(
    null
  );

  private lang = "en";
  private timezone = ""; //Asia/Seoul

  DENY_REGIST_KOREAN = false;

  constructor(
    private network: Network,
    private platform: Platform,
    private keyboard: Keyboard,
    private globalization: Globalization,
    private alertService: AlertService
  ) {
    this.platform.resume.subscribe(() => {
      this._isForeground = true;
    });

    this.platform.pause.subscribe(() => {
      this._isForeground = false;
    });

    this.network.onDisconnect().subscribe(() => {
      this._network.next(false);
    });

    this.network.onConnect().subscribe(() => {
      this._network.next(true);
    });
  }

  init() {
    if (this.isWeb()) {
      return Promise.resolve();
    } else {
      return this.globalization
        .getPreferredLanguage()
        .then(result => {
          this.lang = result.value.substring(0, 2).toLowerCase(); //android : ko-KR, en-US, ios: en-KR, ko-KR
          return this.globalization.getDatePattern({
            formatLength: "short",
            selector: "date and time"
          });
        })
        .then(res => {
          this.timezone = res["iana_timezone"];

          this.DENY_REGIST_KOREAN =
            ENV.DENY_REGIST_KOREAN && this.getCountry() === "KOREA";

          return Promise.resolve();
        })
        .catch(e => {
          return Promise.resolve();
        });
    }
  }

  getLanguage() {
    switch (this.lang) {
      case "zh":
      case "cn":
        return "CHINESE";
      case "ko":
        return "KOREAN";
      case "ja":
        return "JAPANESE";
      default:
        return "ENGLISH";
    }
  }

  getCountry() {
    if (this.timezone === "Asia/Seoul") {
      return "KOREA";
    }
    return "";
  }

  network$(): any {
    return this._network.asObservable();
  }

  isNetworkConnected() {
    return this._network.value;
  }

  get isForground() {
    return this._isForeground;
  }

  proposeStatusTab$(): any {
    return this._proposeStatusTab.asObservable();
  }

  changeProposeStatusTab(status: string) {
    this._proposeStatusTab.next(status);
  }

  setRoot(navCtrl: NavController, name: string, params?: any) {
    navCtrl.setRoot(name, params);
    this.rootPageName = name;

    // this.menuController.enable(this.rootPageName === 'HomePage');
  }

  setFirstPage(navCtrl: NavController) {
    let name = "";

    if (this.DENY_REGIST_KOREAN) name = "LoginPage";
    else name = "TabbarPage";

    navCtrl.setRoot(name);
    this.rootPageName = name;
  }

  getRootPageName() {
    return this.rootPageName;
  }

  isIOSXApp() {
    return !this.isWeb() && this.isIOSApp() && this.platform.height() === 812;
  }

  isWeb() {
    // https://forum.ionicframework.com/t/how-to-determine-if-browser-or-app/89149/12
    // if livereload return http://192.168.219.100:8100/#/conversations
    return (
      this.platform.is("core") ||
      (document.URL.startsWith("http") &&
        !document.URL.startsWith("http://192") &&
        !document.URL.startsWith("http://localhost"))
    );
  }

  isIOSApp() {
    return !this.isWeb() && this.platform.is("ios");
  }

  isAndroidApp() {
    return !this.isWeb() && this.platform.is("android");
  }

  keyboardDisableScroll(disable: boolean) {
    if (!this.isIOSApp()) return;

    this.keyboard.disableScroll(disable);
    window.removeEventListener("native.keyboardshow", this.keyboardShowEvent);
    window.removeEventListener("native.keyboardhide", this.keyboardHideEvent);
    if (disable) {
      window.addEventListener("native.keyboardshow", this.keyboardShowEvent);
      window.addEventListener("native.keyboardhide", this.keyboardHideEvent);
    }
  }

  setupBackbuttonCheckExit() {
    this.unregisterBackButtonAction = this.platform.registerBackButtonAction(
      () => {
        this.customHandleBackButton();
      },
      10
    );
  }

  cancelBackButtonCheckExit() {
    this.unregisterBackButtonAction && this.unregisterBackButtonAction();
  }

  private customHandleBackButton() {
    this.alertService.showConfirmMessage(
      "셀럽 종료",
      "셀럽앱을 종료하시겠습니까? ",
      () => {
        this.platform.exitApp();
      }
    );
  }

  private keyboardShowEvent: any = (e: any) => {
    let appEl: any = <HTMLElement>document.getElementsByTagName("ION-APP")[0];
    let appElHeight: number = this.platform.height();
    appEl.style.height = appElHeight - (<any>e).keyboardHeight + "px";
  };

  private keyboardHideEvent: any = () => {
    let appEl: any = <HTMLElement>document.getElementsByTagName("ION-APP")[0];
    appEl.style.height = "100%";
  };
}



// WEBPACK FOOTER //
// ./src/services/platform.service.ts